import { Injectable } from '@angular/core';

import { HttpClientService } from '../common/http-client.service';

@Injectable({
  providedIn: 'root'
})

export class ReceivableService {

  url: string = 'receivables';

  constructor(private httpClient: HttpClientService) {}

  getSearchOptions(params: any = {}): Promise<any> {
    params.search_options = true;
    return this.httpClient.get(`${this.url}.json`, params);
  }

  index(params: any = {}): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, params)
  }

}